<template>
  <v-app id="inspire">
    <v-main>
      <div class="vertical-center max-width-4 min-width-4">
        <div class="text-center">
          <img alt="Vue logo" src="@/assets/logo_header.svg" />
        </div>
        <v-row align="center" class="mt-5" justify="center">
          <v-card min-width="350" max-width="350" class="elevation-12">
            <v-card-title class="justify-center title">ログイン</v-card-title>
            <div
              class="google-signin-button mb-3 mx-3 text-center"
              @click="login"
              style="cursor: pointer"
              min-width="100%"
            >
              <v-progress-circular
                v-if="loading"
                :size="30"
                :width="2"
                color="white"
                indeterminate
              />
              <v-img
                v-else
                height="35px"
                width="35px"
                max-width="35px"
                class="float-left"
                style="border-radius: 2px"
                :src="logoGoogle"
                aspect-ratio="1.7"
              />

              <span class="ma-auto">Sign in with Google</span>
            </div>
          </v-card>
        </v-row>
      </div>
    </v-main>
  </v-app>
</template>
<script>
import mixin from "@/mixin/";
import logoGoogle from "@/assets/g-logo.png";
import { getMenu } from "@/api/Menu.api";
export default {
  mixins: [mixin.Cognito],
  data: () => ({
    loading: false,
    logoGoogle,
  }),
  computed: {},
  created() {
    let messageError = this.$ls.get("error_group");
    if (messageError) {
      this.$toast.error(messageError);
      this.$ls.clear();
    }
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    async getMenuList() {
      await getMenu().then(({ result }) => {
        this.menuList = result;
        this.$ls.set("Menu_List", result);
      });
    },
  },
};
</script>
<style scoped>
::v-deep .fa-envelope::before,
::v-deep .fa-key::before,
::v-deep .fa-eye-slash::before {
  font-size: 20px;
  margin-right: 8px;
}
.v-card__text {
  padding-bottom: 0;
}
.google-signin-button {
  background-color: #4082ef;
  color: #fff;
  height: auto;
  display: flex;
  padding: 4px;
  border-radius: 3px;
}
</style>
